/**
 * Transform functions to bridge between the form's camelCase data structures
 * and the calculation service's snake_case data structures
 */

import type {
  RateCard as ServiceRateCard,
  ProjectRate as ServiceProjectRate,
  PhaseRole as ServicePhaseRole,
} from "@runn/calculations"

import type { RateCard, BudgetedPhaseAndRole } from "./types"

export const transformFormRoles = (
  roles: ReadonlyArray<{ id: number; estimatedMinutes: number }>,
) => {
  return roles.map((role) => ({
    id: role.id,
    estimated_minutes: role.estimatedMinutes ?? null,
  }))
}

export const transformFormRates = (
  rates: ReadonlyArray<{ roleId: number; rate: number }>,
): ServiceProjectRate[] => {
  return rates.map((rate) => ({
    role_id: rate.roleId,
    rate: rate.rate,
  }))
}

export const transformRateCard = (rateCard: RateCard): ServiceRateCard => {
  return {
    id: rateCard.id,
    blended_rate: rateCard.blended_rate,
    blended_rate_card: rateCard.blended_rate_card,
    role_charge_out_rates: rateCard.role_charge_out_rates.map((rate) => ({
      role_id: rate.role_id,
      charge_out_rate: rate.charge_out_rate,
    })),
  }
}

export const transformPhaseRoles = (
  phaseRoles: ReadonlyArray<BudgetedPhaseAndRole>,
): ServicePhaseRole[] => {
  return phaseRoles.map((pr, index) => ({
    id: pr.phaseRoleId ?? index,
    role_id: pr.roleId,
    phase_id: pr.phaseId,
    estimated_minutes: pr.estimatedMinutes,
  }))
}
